import { HttpClient } from '@/shared/infra/http/HttpClient';
import { PendingCounts } from '../../application/domain/entities/PendingCounts';
import { ReportData } from '../../application/domain/entities/ReportData';
import { ReportsInsightsData } from '../../application/domain/entities/ReportsInsightsData';
import { IDashboardRepository } from '../../application/ports/outbound/IDashboardRepository';
import { DashboardPendingCountsDto } from './dto/DashboardPendingCountsDto';
import { ReportsInsightsDto } from './dto/ReportsInsightsDto';
import { mapDashboardPendingCountsDtoToPendingCounts } from './mappers/dashboardPendingCountsMapper';
import { mapReportsInsightsDtoToEntity } from './mappers/reportsInsightsMapper';

export class ApiDashboardRepository implements IDashboardRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async fetchPendingCounts(): Promise<PendingCounts> {
    const response =
      await this.httpClient.get<DashboardPendingCountsDto>(`dashboard/sections/count`);
    const dto = response.data ?? response;
    return mapDashboardPendingCountsDtoToPendingCounts(dto);
  }

  async fetchReportData(): Promise<ReportData[]> {
    // TODO: Replace with real API call and mapping
    return [
      {
        reportType: 'Summary',
        generatedAt: '2025-12-01',
        status: 'Completed',
      },
      {
        reportType: 'Detail',
        generatedAt: '2025-12-02',
        status: 'Pending',
      },
    ];
  }

  async fetchReportsInsights(): Promise<ReportsInsightsData> {
    const response =
      await this.httpClient.get<ReportsInsightsDto>(`reports-insights`);
    const dto = (response.data ?? response) as ReportsInsightsDto;
    return mapReportsInsightsDtoToEntity(dto);
  }
}
